export class InviteVisitor {
    
    inviterId: number;
    name: string;
    firstname: string;
    phone: string;
    mail: string;

    constructor(inviteVisitor: any = {}) {
        this.inviterId = inviteVisitor?.inviterId;
        this.name = inviteVisitor?.name;
        this.firstname = inviteVisitor?.firstname;
        this.phone = inviteVisitor?.phone;
        this.mail = inviteVisitor?.mail;
    }
}

export class AdditionalVisitor {
    name: string;
    firstname: string;
    phone: string;
    mail: string;
    registrationCode: string;

    constructor(inviteVisitor: any = {}) {
        this.name = inviteVisitor?.name;
        this.firstname = inviteVisitor?.firstname;
        this.phone = inviteVisitor?.phone;
        this.mail = inviteVisitor?.mail;
        this.registrationCode = inviteVisitor.registrationCode;
    }
}